import { render, staticRenderFns } from "./cpt-text.vue?vue&type=template&id=59ec65a2&scoped=true"
import script from "./cpt-text.vue?vue&type=script&lang=js"
export * from "./cpt-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec65a2",
  null
  
)

export default component.exports